/**
 * Feed API slice
 * RTK Query endpoints for the combined feed
 */

import apiSlice from '../api/api.slice';
import { IFeedItem, IFeedRequestParams, IFeedResponse } from './feed.d';

export const feedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Get the combined feed of posts and project groups
     */
    getFeed: builder.query<
      { items: IFeedItem[]; hasMore: boolean; totalCount: number },
      IFeedRequestParams
    >({
      query: (params) => ({
        url: '/api/v1/feed',
        method: 'GET',
        params,
      }),
      transformResponse: (response: IFeedResponse) => ({
        items: response.items,
        hasMore: response.hasMore,
        totalCount: response.totalCount,
      }),
      providesTags: ['Feed'],
    }),
  }),
});

export const { useGetFeedQuery, useLazyGetFeedQuery } = feedApiSlice;
